module.exports = __webpack_public_path__ + "static/media/arrow-top-right.045d9dd8.svg";